import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { PostDataAPI } from './services/PostDataAPI';
import { Container, Grid, Typography, Box } from '@mui/material';
import Header from './components/header';
import Footer from './components/footer';
import SEOTags from './common/SEO';
import Logo from './assets/img/NGF-logo.svg';
import AboutImg from './assets/img/common/about-img.jpg'
import AboutBanner from './assets/img/banner/AboutUsBanner.jpg';
import BlogDetails from './blogDetails';


const Blog = () => {
    const [videoLoaded, setVideoLoaded] = useState(false);
    const loadVideo = () => {
        setVideoLoaded(true);
    };
    const navigate = useNavigate();
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const pageSize = 9;
    const [listNews, setListNews] = useState([]);
    const [error, setError] = useState(null);

    const fetchNews = async () => {
        setLoading(true);
        try {
            const result = await PostDataAPI("blog/GetAllBlog"); // Passing page and pageSize
            if (result.success && result.data) {
                debugger
                setListNews(prevNews => [...prevNews, ...result.data]); // Append new data
                if (result.data.length < pageSize) {
                    setHasMore(false); // Stop further API calls if the data length is less than pageSize
                }
            } else {
                setError(result.message || "No news available.");
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                setError("Failed to fetch news: " + error.message);
            }
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        SEOTags(
            "Blog | Figgers Law",
            "Freddie Figgers, born in Quincy, Florida, is an entrepreneur, and philanthropist dedicated to innovation, community support, and technology solutions.",
            "About, Freddie Figgers"
        );
    }, [])

    useEffect(() => {
        fetchNews()
    }, [])

    const [news, setNews] = useState([]);
    const [newsItem, setNewsItem] = useState(0);

    const [newsDetails, setNewsDetails] = useState(false);

    const openNews = (item) => {
        setNewsItem(item)
        setNewsDetails(true)
    }

    const createSlug = (title) => {
        return title
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/--+/g, '-');
    };


    return (
        <>



            <>

                <Header></Header>
                <div className="about-page-hero" style={{
                    backgroundImage: `url(${AboutBanner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "right",
                }}
                >
                    <div className="container">
                        <h1>Blog</h1>
                        <p>
                            Explore the latest articles, legal insights, firm news, and updates from Figgers Law. Stay informed on important legal topics, developments, and issues that may impact you, your family, or your business.
                        </p>
                    </div>
                </div>

                <section className="highlights" id="highlights">
                    <div className="container">

                        {loading ? (
                            <div className="blog-loader">
                                <div className="small-spinner"></div>
                                <p>Loading blogs...</p>
                            </div>
                        ) : error ? (
                            <div className="blog-error">
                                <p>{error}</p>
                            </div>
                        ) : listNews.length > 0 ? (
                            <div className="highlights-grid">
                                {listNews.map((item, index) => (
                                    <Link
                                        className="highlight-card"
                                        key={item.id || index}

                                    >
                                        <img
                                            src={"/" + item.bannerPath}
                                            alt={item.title || "Blog"}
                                        />

                                        <Link
                                            to={`/blog/${createSlug(item.title)}`}
                                            state={{ newsItem: item }}>
                                            <h3>{item.title}</h3>
                                        </Link>

                                        <p className="text-muted">
                                            {item.shortDescription}
                                        </p>
                                        <Link
                                            to={`/blog/${createSlug(item.title)}`}
                                            state={{ newsItem: item }}
                                            className='read_more'
                                        >
                                            Read More
                                        </Link>
                                        {/* <Link
                                            to="/"
                                            style={{ color: 'rgb(136 81 0)', float: 'right', fontSize: '14px' }}
                                            onClick={(e) => e.stopPropagation()}
                                        >
                                            Read More
                                        </Link> */}
                                    </Link>
                                ))}
                            </div>
                        ) : (
                            <div className="blog-error">
                                <p>No blogs available.</p>
                            </div>
                        )}

                    </div>
                </section>
                <Footer></Footer>
            </>


        </>

    );
};

export default Blog;
